import { useRef } from 'react';
import styled from 'styled-components';

const StyledTextArea = styled.textarea`
  resize: none;
`;

type ResizableTextAreaProps = {
  /** text value of the text area */
  value: string | null;
  /** function to update the text value of the text area */
  onChange: (value: string) => void;
  /** palceholder to show when text area is empty */
  placeholder?: string;
  /** number of max characters for the text area */
  maxLength?: number;
  /** onclick function */
  onClick?: () => void;
  /** is disabled */
  isDisabled?: boolean;
};

export const ResizableTextArea = ({
  value,
  onChange,
  isDisabled = false,
  ...props
}: ResizableTextAreaProps) => {
  const textAreaRef = useRef<HTMLTextAreaElement>(null);

  const onChangeHandler = ({ target }: React.ChangeEvent<HTMLTextAreaElement>) => {
    onChange(target.value);
  };

  return (
    <StyledTextArea
      ref={textAreaRef}
      defaultValue={value || ''}
      onChange={onChangeHandler}
      disabled={isDisabled}
      {...props}
    />
  );
};
